import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

window.addEventListener('DOMContentLoaded', () => {
	const option = {
		modules: [Navigation, Pagination],
		loop: false,
		speed: 800,
		slidesPerView: 1.35,
		spaceBetween: 15,
		pagination: {
			el: ".swiper-sp_only-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2.5,
			},
		},
		navigation: {
			nextEl: ".swiper-sp_only-button-next",
			prevEl: ".swiper-sp_only-button-prev"
		}
	}
	const breakPoint = 768;
	let swiper;
	if ( window.innerWidth <= breakPoint ) {
		swiper = new Swiper('.js-swiper-sp_only', option);

	} else {
		swiper = undefined;
	}
	window.addEventListener('resize', () => {
		if ( window.innerWidth <= breakPoint ) {
			if( swiper ) return;
			swiper = new Swiper('.js-swiper-sp_only', option);
		} else {
			if( !swiper ) return;
			swiper.destroy();
			swiper = undefined;
		}
	}, false);
}, false);


// MV
const homeMVSwiper = () => {
	const homeMV = new Swiper(".js-swiper-home-mv", {
		modules: [Autoplay, EffectFade],
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		initialSlide : 0,
		speed: 3000,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
			waitForTransition: false,
			reverseDirection: false,
		}
	});
};


// 募集 画像のみスライダー
const homerecruitmentgallery = new Swiper(".js-swiper-home-recruitment_gallery", {
	modules: [Navigation, Pagination],
	centeredSlides: false,
	loop: false,
	centeredSlidesBounds: false,
	speed: 800,
	slidesPerView: 1.2,
	spaceBetween: 15,
	breakpoints: {
		767: {
			slidesPerView: 3,
		},
	},
	navigation: {
		nextEl: ".js-swiper-home-recruitment_gallery-button-next",
		prevEl: ".js-swiper-home-recruitment_gallery-button-prev"
	},
	pagination: {
		el: '.js-swiper-home-recruitment_gallery-pagination',
		clickable: true,
	},
});


window.addEventListener('load', function(){
	homeMVSwiper();
});
